var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVersion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 22,
    fill: "url(#pattern0_3576_3617)",
    style: {
      mixBlendMode: "darken"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3576_3617",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3576_3617",
    transform: "scale(0.00740741 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3576_3617",
    width: 135,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAABaCAYAAACSR0X7AAADKElEQVR4AeydC2oDMQxE0x4i9z9fLpEiQggUZK9jyZLsV3DbrGx9Zh7ZUBb6e+MLBRQFgEMRhsu3G3BAgaoAcKjSEAAOGFAVAA5VGgLAAQOqAsChSqMHTol04bjf70/Wvhq0QO/C0TpMbG8FgGNvf6emA44p+fY+PAzH4/H4YdXVYATnYThGkrO3tgLAUds/1+5N4XDtlOTLFQCO5ZLXKQgcdbxa3ilwLJe8TkHgqOPV8k6BY7nkdQoCRx2vlncKHMsl/1cw8UvgSGxOdGvAEe1A4vrAkdic6NaAI9qBxPXd4LB6tHBWO6s+Wnl6PbbOWsZ6fYzG3eAYbUTb/xZPi3PdT4H0cLxHB5K3Eut+5oVD0UAgUUJcNlagHBwyP4CICv6rJBz+slBBFCgLB+8eYp/vCoHjytPrvmO/sl/p48qeV7bvvl/Jf3XPdx3op0Lg0Nv5RESQzyt+i1AgLRwiRg8Qbi2ikt9KDYff2Ltmtp0LOGz13CobcGxlp+0wpeHofSaxleq8bKnh8P7AKfln1u64pIVDTNtdfJlP5vx2yXnPFQLHFTF6Q3NL6Sk0Hw+BY75tMqxQ4BA4Vki5X42ScHBLWQNiSTjkM8saec6uUhKOsy1bN31ZOCzePeT2NLMsbIqu35ohDA5NlFazxNYqEAKHgKGNKbH30vZwfY0CIXBcHU0gae21uLW08h8e4994nQ5Aa/7U7xytxon5KwAc/hqXrQAcZa3zb/xoOOQDrcXytymmwtFwxEhepypw1PFqeafAMS75MSeA4xirxwcFjnHNjjmRHo7en9CPcSpgUDc4xFRtjc6p5ZHrvVyyx3vN9NA7Gxl3gyNyKGrbKAAcNjpumQU4trTVZihLOGw6IksaBYAjjRX5GgGOfJ6k6Qg40liRrxHgyOdJmo6AI40V+RoBjnyepOkIOIKtyFweODK7E9wbcAQbkLk8cGR2J7i3YTgsntYmx/0ZpcEIb8NwjCRnb20FgKO2f67dA4ervLWTd+HwfsROy8/1x88KDVr4duFoHSa2twLAsbe/U9MBx5R8ex8Gjr39nZoOOKbk2/swcOzt79R0fwAAAP//azXyJgAAAAZJREFUAwDSwtEAMDesDAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersion);
export default __webpack_public_path__ + "static/media/version.25c3f12b128ce33f9e79a11f8d536f14.svg";
export { ForwardRef as ReactComponent };